import { useState, useMemo } from 'react';
import { CustomerWithMetrics } from './useDashboardData';

export type SortOption = 'progress' | 'health' | 'days';
export type SegmentOption = 'all' | 'small_business' | 'enterprise' | 'e-commerce';

export const useDashboardFilters = (customers: CustomerWithMetrics[]) => {
  const [selectedSegment, setSelectedSegment] = useState<SegmentOption>('all');
  const [sortBy, setSortBy] = useState<SortOption>('progress');

  const filteredCustomers = useMemo(() => {
    return customers.filter(customer => 
      selectedSegment === 'all' || customer.segment === selectedSegment
    );
  }, [customers, selectedSegment]);

  const sortedCustomers = useMemo(() => {
    return [...filteredCustomers].sort((a, b) => {
      switch (sortBy) {
        case 'progress':
          return b.progress - a.progress;
        case 'health':
          return (b.healthScore || 0) - (a.healthScore || 0);
        case 'days':
          return b.daysInOnboarding - a.daysInOnboarding;
        default:
          return 0;
      }
    });
  }, [filteredCustomers, sortBy]);

  return {
    selectedSegment,
    setSelectedSegment,
    sortBy,
    setSortBy,
    filteredCustomers,
    sortedCustomers,
  };
};